import { render, staticRenderFns } from "./editVideoRecord.vue?vue&type=template&id=30f55b80&scoped=true&"
import script from "./editVideoRecord.vue?vue&type=script&lang=js&"
export * from "./editVideoRecord.vue?vue&type=script&lang=js&"
import style0 from "./editVideoRecord.vue?vue&type=style&index=0&id=30f55b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f55b80",
  null
  
)

export default component.exports